import React from "react";
import { useState } from "react";
import { toast } from "react-toastify";
import Axios from "../../utils/axios";
import "../../style/ForgotPasswordModal.css";

const ForgotPasswordFlow = ({ isOpen, onClose }) => {
  const [step, setStep] = useState("email");
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");

  // Step 1: Send OTP
  const handleSendOtp = async (e) => {
    e.preventDefault();
    if (!email.includes("@") || !email.includes(".")) {
      toast.error("Please enter a valid email address");
      return;
    }
    try {
      const res = await Axios.post(
        `${process.env.REACT_APP_AUTH_BASE_URL}/api/forgotPassword/generateotp`,
        {
          email,
        }
      );
      toast.success(res.data?.message || "OTP sent!");
      setStep("otp");
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to send OTP");
    }
  };

  // Step 2: Verify OTP
  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    if (!otp.trim()) {
      toast.error("Please enter OTP");
      return;
    }
    try {
      const res = await Axios.post(
        `${process.env.REACT_APP_AUTH_BASE_URL}/api/forgotPassword/verifyotp`,
        { email, otp }
      );
      toast.success(res.data?.message || "OTP verified!");
      setStep("reset");
    } catch (error) {
      toast.error(error.response?.data?.message || "Invalid OTP");
    }
  };

  // Step 3: Reset Password
  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmNewPassword) {
      toast.error("Passwords do not match");
      return;
    }
    try {
      const res = await Axios.post(
        `${process.env.REACT_APP_AUTH_BASE_URL}/api/forgotPassword/reset`,
        { email, otp, newPassword, confirmNewPassword }
      );
      toast.success(res.data?.message || "Password reset successful!");
      onClose();
      setStep("email");
      setEmail("");
      setOtp("");
      setNewPassword("");
      setConfirmNewPassword("");
    } catch (error) {
      toast.error(error.response?.data?.message || "Password reset failed");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <button className="modal-close-button" onClick={onClose}>
          &times;
        </button>

        {step === "email" && (
          <form onSubmit={handleSendOtp}>
            <h3>Forgot Password</h3>
            <div className="form-group">
              <label>Email Address</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="modal-actions">
              <button type="submit" className="send-btn">
                Send OTP
              </button>
            </div>
          </form>
        )}

        {step === "otp" && (
          <form onSubmit={handleVerifyOtp}>
            <h3>Verify OTP</h3>
            <div className="form-group">
              <label>OTP</label>
              <input
                type="text"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                required
              />
            </div>
            <div className="modal-actions">
              <button type="submit" className="send-btn">
                Verify OTP
              </button>
            </div>
          </form>
        )}

        {step === "reset" && (
          <form onSubmit={handleResetPassword}>
            <h3>Reset Password</h3>
            <div className="form-group">
              <label>New Password</label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label>Confirm New Password</label>
              <input
                type="password"
                value={confirmNewPassword}
                onChange={(e) => setConfirmNewPassword(e.target.value)}
                required
              />
            </div>
            <div className="modal-actions">
              <button type="submit" className="send-btn">
                Reset Password
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordFlow;
